"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _QuestionEntityRecord = _interopRequireDefault(require("composer-plugins/plugins/questionAndAnswer/QuestionEntityRecord"));

var _UISelectableBox = _interopRequireDefault(require("UIComponents/button/UISelectableBox"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var FreeformQuickAnswerContent = function FreeformQuickAnswerContent(_ref) {
  var question = _ref.question,
      disabled = _ref.disabled,
      onSubmissionChanged = _ref.onSubmissionChanged;
  return _react.default.createElement("div", {
    className: "m-bottom-3"
  }, question.quickAnswers.map(function (answer) {
    var selected = question.selected.includes(answer);
    return _react.default.createElement(_UISelectableBox.default, {
      key: answer,
      selected: selected,
      className: "p-all-1 m-left-0 m-bottom-1 m-right-1",
      style: {
        minWidth: 50
      },
      onClick: function onClick() {
        return onSubmissionChanged(question.selectOption(answer));
      },
      disabled: disabled,
      "data-selenium-test": "q-and-a-quick-answer"
    }, _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "center"
    }, _react.default.createElement(_Small.default, null, answer)));
  }));
};

FreeformQuickAnswerContent.propTypes = {
  question: _react.PropTypes.instanceOf(_QuestionEntityRecord.default).isRequired,
  disabled: _react.PropTypes.bool.isRequired,
  onSubmissionChanged: _react.PropTypes.func
};
var _default = FreeformQuickAnswerContent;
exports.default = _default;
module.exports = exports.default;